import { RowDataTransaction } from 'ag-grid-community'
import { isEqual } from 'lodash'

export type ApplyTransactionGetId<T = any> = (data: T) => string

export function createRowDataTransaction<T>(getId: ApplyTransactionGetId<T>, newRows: T[], oldRows: T[] = []): RowDataTransaction {
  if (newRows.length === 0 && oldRows.length === 0) {
    return {}
  } else if (newRows.length === 0 && oldRows.length > 0) {
    return { remove: oldRows }
  } else if (oldRows.length === 0) {
    return { add: newRows }
  } else {
    const byId = getById(getId)

    const oldDict = byId(oldRows)
    const newDict = byId(newRows)

    const add = newRows.filter(item => !oldDict[getId(item)])
    const remove = oldRows.filter(item => !newDict[getId(item)])
    const update = newRows.filter(newItem => {
      const oldItem = oldDict[getId(newItem)]
      return oldItem && !isEqual(newItem, oldItem)
    })

    const transaction: RowDataTransaction = {}

    if (add.length) {
      transaction.add = add
    }

    if (remove.length) {
      transaction.remove = remove
    }

    if (update.length) {
      transaction.update = update
    }

    return transaction
  }
}

type ById<T> = Record<string, T | undefined>

function getById<T>(getId: ApplyTransactionGetId<T>) {
  return function toByIds(collection: T[]): ById<T> {
    return collection.reduce((result, item) => {
      const id = getId(item)
      result[id] = item
      return result
    }, {} as ById<T>)
  }
}
